import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f6d213f4&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f6d213f4&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=f6d213f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d213f4",
  null
  
)

export default component.exports